import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation UpdateReportLayoutMutation(
    $input: UpdateReportLayoutInput!
  ) {
    updateReportLayout(input: $input) {
      report {
        id
        mongoId
        name
        layout {
          i
          x
          y
          w
          h
        }
      }
    }
  }
`;

function commit({reportId, layout}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          layout: layout.map(widgetPosition => {
            return {
              i: widgetPosition.i,
              x: widgetPosition.x,
              y: widgetPosition.y,
              w: widgetPosition.w,
              h: widgetPosition.h,
            };
          }),
        },
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/UpdateReportLayoutMutation.js